import axios from "axios";
import { environment } from "@/data/environment";

const actions = {
    async getEntities({ commit, state }, { idCompany, application, token }) {
        try {
            const { data } = await axios.get(
                `${environment.HIOPOSWEBSERVICES}/api/exogena/companies/${idCompany}/entities`,
                {
                    params: {
                        application,
                    },
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            return Array.isArray(data) ? data : [];

        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async companyParameters({ commit, state }, { idCompany, token }) {
        try {
            const { data } = await axios.get(
                `${environment.HIOPOSWEBSERVICES}/api/exogena/companies/${idCompany}/companyParameters`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            return Array.isArray(data) ? data : [];
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async getEntitiesImport({ commit, state }, { idCompany, token }) {
        try {
            const { data } = await axios.get(
                `${environment.HIOPOSWEBSERVICES}/api/exogena/companies/${idCompany}/entities/imports`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            return Array.isArray(data) ? data : [];
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async testConnectionBridge({ commit }, {idCompany, token, authenticationBridgeWS}) {
        try {
            const { data } = await axios.post(
                `${environment.HIOPOSWEBSERVICES}/api/exogena/companies/${idCompany}/bridgesWS/test`,
                {
                    authenticationBridgeWS,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            return data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async sendFileImport({ commit }, {idCompany, token, entity, file, startDate, endDate, requiresDateRange}) {
        try {
            const formData = new FormData();

            formData.append("entity", entity);
            formData.append("jsonFile", file);

            if (requiresDateRange) {
                formData.append("startDate", startDate);
                formData.append("endDate", endDate);
            }

            const { data } = await axios.post(
                `${environment.HIOPOSWEBSERVICES}/api/exogena/companies/${idCompany}/entities/importByFile`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            return data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async sendBridgeImport({ commit }, {idCompany, token, dataFilter, parameters, companyAccountant}) {
        try {
            const payload = {
                entities: dataFilter.entities.map(e => ({
                    
                    name: e.entityCode,
                    rangeDate: e.requiresDateRange === true
                    ? {
                        startDate: dataFilter.startDateBridge,
                        endDate: dataFilter.endDateBridge,
                        }
                    : null
                })),

                authenticationBridgeWS: {
                    email: parameters.userBridge,
                    password: parameters.passwordBridge,
                },
                accountingCompanyCode: companyAccountant
            };

            const { data } = await axios.post(
                `${environment.HIOPOSWEBSERVICES}/api/exogena/companies/${idCompany}/entities/importByBridgeWS`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            return data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
};

const mutations = {
    setEntities(state, entities) {
        state.entities = entities;
    },
};

const state = {
    entities: [],
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};